import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BaseGroupType, CommonHierarchyDropdownData, DataItem, DataList, DESIRED_HIERARCHY_ORDER, ETLBasefeed, ETLReportingSetJoinedFeedsList, HierarchyItem } from '../../cxone-etl-reporting-set.model';
import { ToastrManager } from '@niceltd/cxone-components/toastr';
import { CxoneEtlReportingSetService } from '../../cxone-etl-reporting-set.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import moment from "moment";
import { Subscription } from 'rxjs';

interface BooleanDropDownOptions {
    id: number;
    name: string;
}
@Component({
    selector: 'cv-cxone-etl-reporting-set-joined-feed',
    templateUrl: './cxone-etl-reporting-set-joined-feed.component.html',
    styleUrls: ['./cxone-etl-reporting-set-joined-feed.component.scss']
})
export class CxoneEtlReportingSetJoinedFeedComponent implements OnInit {

    constructor(
        private toasterManager: ToastrManager,
        private cvLocalizationService: CVLocalizationService,
        private cxoneEtlReportingSetService: CxoneEtlReportingSetService,
        private fb: FormBuilder,
    ) { }

    private reportingSetJoinedFeedSubscription: Subscription;
    public feed2Options: ETLBasefeed[];
    public feednamesList: ETLBasefeed[] = [];
    public feed1Options: ETLBasefeed[] = [];
    public reportingSetJoinedFeed: FormGroup;
    public field2Options: DataList[] = [];
    public field1Options: DataList[] = [];
    public dropdownPlaceholderText = '';
    public feedNamePlaceholderText = '';
    public comparisonValuePlaceholder = '';
    public checkboxLabel = '';
    @Input() reportingSetForm: any;
    @Input() reportingSetJoinedFeedsList;
    @Output() formValid = new EventEmitter<boolean>();
    public editjoinedFeed = false;
    /** To store previously selected Field1 to check and compare with new selection */
    public previousSelectedField1: ETLBasefeed | ETLReportingSetJoinedFeedsList;
    /** To store previously selected Field2 to check and compare with new selection */
    public previousSelectedField2: ETLBasefeed | ETLReportingSetJoinedFeedsList;
    _joinedFeedData: ETLReportingSetJoinedFeedsList;
    filterComparedSText = {
        field1: [],
        field2: []
    };
    public FilterField1DataType = -1;
    public FilterField2DataType = -1;
    public Field1NumericValue = 0;
    public Field1DateValue = new Date();
    public Field1BooleanValue;
    public Field2NumericValue = 0;
    public Field2DateValue = new Date();
    public Field2BooleanValue;
    booleanDropDownOptions: BooleanDropDownOptions[] = [];
    public feed2OptionsData: ETLBasefeed[];
    hierarchyDefData = [];

    dataTypeMapping = {
        0: "Text",
        1: "Whole Number",
        2: "Decimal Number",
        3: "Date",
        4: "True/False"
    };

    get allowDay() {
        return this._joinedFeedData;
    }

    get handleFilterField1Comparison() {
        return this.reportingSetJoinedFeed.get("filterField1Comparison");
    }

    get handleFilterField2Comparison() {
        return this.reportingSetJoinedFeed.get("filterField2Comparison");
    }

    @Input('joinedFeedData') set joinedFeedData(value: ETLReportingSetJoinedFeedsList) {
        this._joinedFeedData = value;
        this.initializeReportingSetJoinedFeedForm();
        this.loadBasefeedData();
        this.reportingSetJoinedFeedSubscription = this.reportingSetJoinedFeed.valueChanges.subscribe(() => {
            if (this.reportingSetJoinedFeed.dirty) {
                this.formValid.emit(this.reportingSetJoinedFeed.valid);
                sendMessageCXOne({ hasNonSavedChanges: true });
            }
        })
        this.updateFeed1Options();
    }

    async ngOnInit() {
        this.booleanDropDownOptions = [
            { id: 1, name: 'True' },
            { id: 0, name: 'False' },
        ];
        await this.loadLocalization();
        this.handleFilterField1Comparison.disable();
        this.handleFilterField2Comparison.disable();
    }

    updateFeed1Options() {
        this.feed1Options = [];
        if (this.reportingSetForm && this.reportingSetForm.basefeed) {
            this.feed1Options.push({
                id: 0, name: this.reportingSetForm.basefeed.FeedName + " (" + this.reportingSetForm.basefeed.SourceSystem + ")",
                feed2: undefined
            });
        }
        let joinedFeeds = this.reportingSetJoinedFeedsList.map((item, i) => {
            return { id: i + 1, name: item.joinedFeedName, ...item }
        });
        this.feed1Options = [...this.feed1Options, ...joinedFeeds];
    }

    async loadLocalization() {
        try {
            await this.cvLocalizationService.GetSection('ETL_Reporting_Set');
        }
        catch {
            console.log('Failed to load localization for ETL_Reporting_Set');
        }
        finally {
            this.dropdownPlaceholderText = this.getLocalizationString("Select_Item", "Select...");
            this.feedNamePlaceholderText = this.getLocalizationString("Enter_Feed_Name", "Enter feed name");
            this.comparisonValuePlaceholder = this.getLocalizationString("Enter_Comparison_Value", "Enter comparison value");
            this.checkboxLabel = this.getLocalizationString("Required_Join", "Required Join")
        }
    }

    public async loadBasefeedData() {
        this.feed2OptionsData = [];
        try {
            this.feednamesList = await this.cxoneEtlReportingSetService.loadBasefeed();
            await this.hierarchyDefinitions();
        }
        catch (error) {
            this.toasterManager
                .showToaster('error',
                    this.getLocalizationString('Internal_Server_Error', 'Internal server error. Try again.'));
        }
        finally {
            this.feed2OptionsData = this.feednamesList.map(item => {
                return { dropdownOptions: item.FeedName + " (" + item.SourceSystem + ")", ...item }
            });
            this.feednamesList = [...this.feednamesList, ...this.hierarchyDefData];
            this.feed2Options = [...this.feed2OptionsData, ...this.hierarchyDefData];
            this.updateForm();
            if (Object.keys(this._joinedFeedData).length > 0) {
                this.feed1SelectionChanged();
                this.feed2SelectionChanged();
            }
        }
    }

    public async hierarchyDefinitions() {
        const hierarchyDefData = await this.cxoneEtlReportingSetService.hierarchyDefinitions();
        this.hierarchyDefData = hierarchyDefData.data.map(item => {
            const groupType = BaseGroupType[item.BaseGroupType];
            // Return the constructed object
            return {
                dropdownOptions: `${item.PseudoFeedName} (${groupType})`,
                FeedName: `${item.PseudoFeedName}_${item.BaseGroupType}`,
                DataList: item.MetaData,
                CompanyID: item.CompanyID
            };
        });
        this.hierarchyDefData.sort((a, b) => {
            return DESIRED_HIERARCHY_ORDER.indexOf(a.dropdownOptions) - DESIRED_HIERARCHY_ORDER.indexOf(b.dropdownOptions);
        });
        this.hierarchyDefData = this.transformData(this.hierarchyDefData);
    }

    public transformData = (data): HierarchyItem[] => {
        return data.map(item => {
            let transformedDataList: DataItem[] = Object.keys(item.DataList).map(key => {
                const dataItem = item.DataList[key];
                return {
                    Name: key,
                    ...dataItem,
                    DataType: dataItem.ExpectedType
                };
            });

            transformedDataList = [...CommonHierarchyDropdownData, ...transformedDataList];
            return {
                ...item,
                DataList: transformedDataList
            };
        });
    };

    public getLocalizationString(key: string, defaultValue: string): string {
        const baseString = this.cvLocalizationService.getCachedText("ETL_Reporting_Set", key, defaultValue);
        return baseString;
    }

    public initializeReportingSetJoinedFeedForm() {
        this.reportingSetJoinedFeed = this.fb.group({
            joinedFeedName: new FormControl('', Validators.required),
            checkbox: new FormControl(false),
            feed1: new FormControl('', Validators.required),
            feed2: new FormControl('', Validators.required),
            joinedFields: new FormArray([
                this.fb.group({
                    field1: new FormControl('', Validators.required),
                    field2: new FormControl('', Validators.required),
                })
            ]),
            filterField1: new FormControl(''),
            filterField2: new FormControl(''),
            filterField1Comparison: new FormControl(''),
            filterField2Comparison: new FormControl('')
        });
        this.filterComparedSText = {
            field1: [],
            field2: []
        };
    }

    updateForm() {
        if (Object.keys(this._joinedFeedData).length > 0) {
            this.editjoinedFeed = true;
            this.reportingSetJoinedFeed.patchValue({
                joinedFeedName: this._joinedFeedData.joinedFeedName,
                checkbox: this._joinedFeedData.checkbox,
                feed1: this._joinedFeedData.feed1,
                feed2: this._joinedFeedData.feed2,
            });
            setTimeout(() => {
                let newJoinedFieldsArray = new FormArray([]);
                this._joinedFeedData.joinedFields.forEach(joinedField => {
                    let field1 = this.field1Options.find(item => item.Name === joinedField.field1.Name);
                    let field2 = this.field2Options.find(item => item.Name === joinedField.field2.Name);
                    const field1MatchingItem = CommonHierarchyDropdownData.find(item => item.key === joinedField.field1.Name);
                    const field2MatchingItem = CommonHierarchyDropdownData.find(item => item.key === joinedField.field2.Name);
                    if (field1MatchingItem && !field1) {
                        field1 = {
                            DataType: field1MatchingItem.DataType,
                            Name: field1MatchingItem.Name,
                            dropdownOptions: `${field1MatchingItem.Name} - ${this.dataTypeMapping[field1MatchingItem.DataType]}`
                        }
                    }
                    if (field2MatchingItem && !field2) {
                        field2 = {
                            DataType: field2MatchingItem.DataType,
                            Name: field2MatchingItem.Name,
                            dropdownOptions: `${field2MatchingItem.Name} - ${this.dataTypeMapping[field2MatchingItem.DataType]}`
                        }
                    }
                    let newJoinedFields = this.fb.group({
                        field1: new FormControl(field1 || joinedField.field1, Validators.required),
                        field2: new FormControl(field2 || joinedField.field2, Validators.required),
                    });
                    newJoinedFieldsArray.push(newJoinedFields);
                });
                this.reportingSetJoinedFeed.setControl('joinedFields', newJoinedFieldsArray);
            }, 0);
            this.filterComparedSText = JSON.parse(JSON.stringify(this._joinedFeedData.filterComparedSText));
        } else {
            this.editjoinedFeed = false;
        }
    }

    addJoinedFields() {
        let joinedFieldsArray = this.reportingSetJoinedFeed.get('joinedFields') as FormArray;
        let newJoinedFields = this.fb.group({
            field1: new FormControl('', Validators.required),
            field2: new FormControl('', Validators.required),
        });
        joinedFieldsArray.push(newJoinedFields);
    }

    removeJoinedFields(i: number) {
        let joinedFieldsArray = this.reportingSetJoinedFeed.get('joinedFields') as FormArray;
        joinedFieldsArray.removeAt(i)
    }

    feed1SelectionChanged() {
        let feed1 = this.reportingSetJoinedFeed.get('feed1').value;
        if (this.previousSelectedField1 !== feed1) {
            if (!Object.keys(this._joinedFeedData).length && this.previousSelectedField1 && !this.previousSelectedField1.id) {
                this.filterComparedSText['field1'] = [];
                this.clearJoins();
            }
            this.previousSelectedField1 = feed1;
        }

        let fieldOptions = [];
        if (feed1.id === 0) {
            fieldOptions = this.reportingSetForm.basefeed.DataList;
        } else {
            let feedname = this.feed1Options.find(item => item.name == feed1.name).feed2.FeedName;
            let feed = this.feednamesList.find(item => item.FeedName === feedname);
            if (feedname && feed && feed.DataList) {
                fieldOptions = feed.DataList;
            }
        }

        this.field1Options = fieldOptions.map(item => {
            return { dropdownOptions: item.Name + " - " + this.dataTypeMapping[item.DataType], ...item }
        });
    }

    feed2SelectionChanged() {
        let feed2 = this.reportingSetJoinedFeed.get('feed2').value;
        if (this.previousSelectedField2 !== feed2) {
            if (!Object.keys(this._joinedFeedData).length && this.previousSelectedField2 && !this.previousSelectedField2.id) {
                this.filterComparedSText['field2'] = [];
                this.clearJoins();
            }
            this.previousSelectedField2 = feed2;
        }

        let fieldOptions = this.feed2Options.find(item => item.FeedName === feed2.FeedName).DataList;
        this.field2Options = fieldOptions.map(item => {
            return { dropdownOptions: item.Name + " - " + this.dataTypeMapping[item.DataType], ...item }
        });
    }

    SetFilterField1DataType(e) {
        this.FilterField1DataType = e.DataType;
        if (e) {
            this.handleFilterField1Comparison.enable();
        } else {
            this.handleFilterField1Comparison.disable();
        }
    }

    SetFilterField2DataType(e) {
        this.FilterField2DataType = e.DataType;
        if (e) {
            this.handleFilterField2Comparison.enable();
        } else {
            this.handleFilterField2Comparison.disable();
        }
    }

    clearJoins() {
        let feedJoins = this.reportingSetJoinedFeed.controls.joinedFields['controls'];
        if (feedJoins) {
            while (feedJoins.length > 1) {
                feedJoins.pop();
            }
        }

        this.reportingSetJoinedFeed.patchValue({
            joinedFields: [
                {
                    field1: '',
                    field2: '',
                }
            ],
        });
    }

    compareValue(field: string) {
        let filterFieldText = this.reportingSetJoinedFeed.get(`filterField${field}`).value.Name;

        let fieldDataType = this.reportingSetJoinedFeed.get(`filterField${field}`).value.DataType;
        let fieldCompareText;
        if (fieldDataType === 4) {
            if (field == '1') {
                fieldCompareText = this.Field1BooleanValue.name;
            }
            else {
                fieldCompareText = this.Field2BooleanValue.name;
            }
        }
        else if (fieldDataType === 3) {
            if (field == '1') {
                fieldCompareText = moment(this.Field1DateValue).format('MMM D, YYYY h:mm A');
            }
            else {
                fieldCompareText = moment(this.Field2DateValue).format('MMM D, YYYY h:mm A');
            }
        }
        else {
            fieldCompareText = this.reportingSetJoinedFeed.get(`filterField${field}Comparison`).value;
        }
        this.filterComparedSText[`field${field}`].push(filterFieldText + ' = ' + fieldCompareText);
        this.reportingSetJoinedFeed.controls[`filterField${field}Comparison`].setValue('');

        this.reportingSetJoinedFeed.patchValue({
            [`filterField${field}Comparison`]: '',
            [`filterField${field}`]: ''
        });
        if (this.reportingSetJoinedFeed.valid) {
            this.formValid.emit(true);
        }
    }

    get disableAddButton() {
        return (field: number) => {
            let disableButton = (!this.reportingSetJoinedFeed.controls[`filterField${field}`].value || !this.reportingSetJoinedFeed.controls[`filterField${field}Comparison`].value);
            let fieldDataType = this.reportingSetJoinedFeed.controls[`filterField${field}`].value.DataType;
            if (fieldDataType === 3) {
                if (field === 1) {
                    disableButton = !(this.Field1DateValue instanceof Date && !isNaN(this.Field1DateValue.getTime()));
                }
                else {
                    disableButton = !(this.Field2DateValue instanceof Date && !isNaN(this.Field2DateValue.getTime()));
                }
            }
            return disableButton;
        };
    }

    removeComparedText(field: string, i: number) {
        this.filterComparedSText[`field${field}`].splice(i, 1);
        if (this.filterComparedSText.field1.length === 0 || this.filterComparedSText.field2.length === 0) {
            this.formValid.emit(false);
        }
    }

    ngOnDestroy() {
        if (this.reportingSetJoinedFeedSubscription) {
            this.reportingSetJoinedFeedSubscription.unsubscribe();
        }
    }
}
